import { GenericTableRow } from "./GenericTable";
import { TableCell } from "@mui/material";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import DraggableTableRow from "./DraggableTableRow";

type DraggableTableProps = {
  renderedRows: GenericTableRow[];
  activeRow: number | null;
  shouldAddOnHover?: boolean;
  onAddClick?: (index: number) => void;
};

const DraggableTable = ({
  renderedRows,
  activeRow,
  shouldAddOnHover,
  onAddClick,
}: DraggableTableProps) => {
  return (
    <SortableContext
      items={renderedRows.map((row) => row.item.id)}
      strategy={verticalListSortingStrategy}
    >
      {renderedRows.map((row, index) => (
        <DraggableTableRow
          key={row.item.id}
          id={row.item.id}
          activeRow={activeRow}
          index={index}
          canAddRowOnHover={shouldAddOnHover}
          onAddClick={onAddClick}
        >
          {row.values.map(({ label, value, customCSS }) => (
            <TableCell key={value} component="th" scope="row" style={customCSS}>
              {label}
            </TableCell>
          ))}
        </DraggableTableRow>
      ))}
    </SortableContext>
  );
};

export default DraggableTable;
